import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { ChapterComponent } from '@core/components/chapter/chapter.component';
import { EmptyComponent, EmptyProps } from '@core/components/empty/empty.component';
import { NoContentStubComponent } from '@core/components/no-content-stub/no-content-stub.component';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { AccountService, FeaturesService } from '@core/services';
import { Store } from '@ngrx/store';

import { ErrorNotificationService } from '@shared/error-notification/error-notification.service';
import { SkeletonComponent } from '@shared/skeleton/skeleton.component';
import { getMe } from '@store/reducers/profile.reducer';
import { FeatureEnum, User, UserStatusEnum } from 'lingo2-models';
import { takeUntil } from 'rxjs/operators';
import { AbstractPane } from '../models/abstract-pane';

import { TutorMiniComponent } from '../my-classes-tutors/tutor-mini/tutor-mini.component';

@Component({
  selector: 'app-my-classes-students',
  standalone: true,
  imports: [
    LocaleSharedModule,
    CommonModule,
    SpinnersModule,
    RouterModule,

    NoContentStubComponent,
    ChapterComponent,
    EmptyComponent,
    SkeletonComponent,
    TutorMiniComponent,
  ],
  templateUrl: './my-classes-students.component.html',
  styleUrls: ['./my-classes-students.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyClassesStudentsComponent extends AbstractPane implements OnInit, OnDestroy {
  public isGuest: boolean;

  private _me: User;
  public showEmptyContent: boolean;
  public emptyContent: EmptyProps;
  public showSkeleton = true;

  errorNotificationService = inject(ErrorNotificationService);
  protected features = inject(FeaturesService);
  protected store = inject(Store);
  protected router = inject(Router);

  protected onContentLoaded() {
    this.isVisible = true;
    this.showEmptyContent = !this.users.length && this.pane.display_mode !== 'row';
    this.showSkeleton = false;
    this.detectChanges();
  }

  hasContent(): boolean {
    return this.isAsIfTeacher(); // блок показываем только учителям
  }

  onShowUser(user: User): void {
    this.router.navigate(AccountService.accountRoute(user)).catch();
  }

  public get showSection() {
    return this.features.isAvailable(FeatureEnum.my_classes_students) || AccountService.isAsIfTeacher(this._me);
  }

  ngOnInit() {
    this.store
      .select(getMe)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (me) => {
          this._me = me;
          this.isGuest = me?.status === UserStatusEnum.guest;
          this.emptyContent = {
            title: 'my-classes.no-students.title',
            text: this.isAsIfTeacher() ? 'my-classes.no-students.text_teacher' : 'my-classes.no-students.text',
            link: '/students',
            link_label: '',
            link2: '/my-classes/students',
            image: 'students',
          };
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
  }

  public isAsIfTeacher(): boolean {
    return AccountService.isAsIfTeacher(this._me);
  }

  public trackByFn(index) {
    return index;
  }
}
